import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export const useDepartments = () => {
  const [departments, setDepartments] = useState([]);
  const reload = useCallback(() => api.get("/departments").then((r) => setDepartments(r.data)), []);
  useEffect(() => {
    reload();
  }, [reload]);
  return { departments, reload };
};
